import React from 'react';
import BlogPage from './BlogPage/BlogPage';

const Blog = () => {
    return (
        <div>
            <BlogPage />
        </div>
    );
};

export default Blog;
